const isGeneralError = key => key === 'general';
const isValid = (errors, key) => errors[key] && errors[key] !== true;

export default function showGeneralError(errors) {
    let showError = true;
    Object.keys(errors).forEach(key => {
        if (!isGeneralError(key) && isValid(errors, key)) {
            showError = false;
        }
    });

    return showError;
}
